import { useState } from 'react'
import { Flex, Text } from '@radix-ui/themes'
import { ChevronDownIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { formatEpisodeRange } from './format'
import { LeakV0Json } from './LeakV0Json'
import { LeakV0PanelBox } from './LeakV0PanelBox'
import type { StationLeakV0Episode } from './useLeakV0Episodes'

interface LeakV0RawJsonPanelProps {
  episode: StationLeakV0Episode | null
}

const JsonSection = ({ label, value }: { label: string; value: unknown }) => (
  <Flex direction="column" gap="1">
    <Text size="1" color="gray">
      {label}
    </Text>
    <LeakV0Json value={value} />
  </Flex>
)

export const LeakV0RawJsonPanel = ({ episode }: LeakV0RawJsonPanelProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (episode === null) {
    return (
      <LeakV0PanelBox title="Raw episode JSON">
        <Text size="2" color="gray">
          No episode in the visible window to show a payload for.
        </Text>
      </LeakV0PanelBox>
    )
  }

  return (
    <LeakV0PanelBox
      title={
        <Flex asChild align="center" gap="2" wrap="wrap" width="100%">
          <button
            type="button"
            aria-expanded={isExpanded}
            onClick={() => setIsExpanded((expanded) => !expanded)}
            className="cursor-pointer text-left"
          >
            {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            Raw episode JSON
            <Text size="1" weight="regular" color="gray">
              {formatEpisodeRange(episode)}
            </Text>
          </button>
        </Flex>
      }
    >
      {isExpanded ? (
        <Flex direction="column" gap="3">
          {/* Verbatim: the volumes in here are m³, not the litres the panels above render. */}
          <JsonSection label="evidence_payload" value={episode.evidencePayload} />
          <JsonSection label="events[]" value={episode.events} />
        </Flex>
      ) : null}
    </LeakV0PanelBox>
  )
}
